import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout-Route fuer /objekte. Reine Wrapper-Komponente — Listen-Inhalt liegt in
 * objekte.index.tsx, Detail-/Form-Routen (objekte.$id.tsx, objekte.neu.tsx) werden ueber
 * den Outlet hier gerendert.
 *
 * Vorher hatte objekte.tsx selbst die Listen-Komponente — TanStack file-based
 * Routing hat sie aber als Parent fuer die Child-Routen erkannt. Ohne Outlet
 * sind Children nie gerendert; Klick auf "/objekte/neu" zeigte still die Liste.
 */
export const Route = createFileRoute('/objekte')({
  component: ObjekteLayout,
});

function ObjekteLayout() {
  return <Outlet />;
}
